export const data = {
  termsOfUse: {
    term: 'Este documento e todo o conteúdo do site é oferecido pela SIOON, neste termo representado apenas pela SIOON que regulamenta todos os direitos e obrigações com todos que acessam o site, resguardando todos os direitos previstos na legislação.',
    privacy:
      'Na SIOON, privacidade e segurança são prioridades e nos comprometemos com a transparência do tratamento de dados pessoais dos nossos usuários/clientes. Por isso, esta presente Política de Privacidade estabelece como é feita a coleta, uso e transferência de informações de clientes ou outra.',
  },
};
